export default {"src":"/_next/static/media/Arrow-link.397201e9.svg","height":25,"width":25};